import { render, staticRenderFns } from "./TemplateUploaderComponent.vue?vue&type=template&id=2faa9953"
import script from "./TemplateUploaderComponent.vue?vue&type=script&lang=js"
export * from "./TemplateUploaderComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports